import borderRadiusAndWidthSrc from '@strata/strata-ui/source-of-truth/ui.border-radius-and-width.json';
import spacingSrc from '@strata/strata-ui/source-of-truth/ui.spacing.json';
import typographySrc from '@strata/strata-ui/source-of-truth/ui.typography.json';
import variablesSrc from '@strata/strata-ui/source-of-truth/ui.variables.json';
import classNames from 'classnames';

import { Token } from 'components/designSystem/designTokens/Token';
import { TokenSectionHeader } from 'components/designSystem/designTokens/TokenSectionHeader';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const borderRadius = borderRadiusAndWidthSrc.border_radius;
const borderWidth = borderRadiusAndWidthSrc.border_width;
const fontFamily = typographySrc.font_family;
const fontSizes = typographySrc.font_sizes;
const fontWeights = typographySrc.font_weights;
const variablesOrganized: (typeof variablesSrc)[] = [];
const variablesCategories: string[] = [];

variablesSrc.forEach((variable) => {
    const cat = variable.category;

    // sort by category
    if (!variablesCategories.includes(cat)) {
        variablesCategories.push(cat);
        variablesOrganized.push(variablesSrc.filter((x) => x.category === cat));
    }
});

const tokenborderRadius = [
    <TokenSectionHeader key="1" />,
    <div key="2">
        {borderRadius.map((border) => (
            <Token
                key={border.variable_name}
                variableName={border.variable_name}
                value={border.value}
                uses={border.uses}
                example={
                    <div
                        className={classNames(`sds_border-example__radius`, {
                            'sds_border-example__circle': border.value === '50%',
                        })}
                        style={{ borderRadius: border.value }}
                    />
                }
            />
        ))}
    </div>,
];

const tokenborderWidth = [
    <TokenSectionHeader key="3" />,
    <div key="4">
        {borderWidth.map((border) => (
            <Token
                key={border.variable_name}
                variableName={border.variable_name}
                value={border.value}
                uses={border.uses}
                example={
                    <div
                        className="sds_border-example__width"
                        style={{ borderWidth: border.value }}
                    />
                }
            />
        ))}
    </div>,
];

const tokenSpacing = [
    <TokenSectionHeader key="5" />,
    <div key="6">
        {spacingSrc.map((space) => (
            <Token
                key={space.variable_name}
                variableName={space.variable_name}
                value={space.value}
                uses={space.uses}
                example={<div className="sds_spacing-example" style={{ height: space.value }} />}
            />
        ))}
    </div>,
];

const tokenfontFamily = [
    <TokenSectionHeader key="7" />,
    <div key="8">
        {fontFamily.map((font) => (
            <Token
                key={font.variable_name}
                variableName={font.variable_name}
                value={font.value}
                uses={font.uses}
                example={
                    <div className="sds_typography__family">
                        Enhancing the specialty pharmacy system for the benefit of pharmacies,
                        payers and patients.
                    </div>
                }
            />
        ))}
    </div>,
];

const tokenfontSizes = [
    <TokenSectionHeader key="9" />,
    <div key="10">
        {fontSizes.map((size) => (
            <Token
                key={size.variable_name}
                variableName={size.variable_name}
                value={size.value}
                uses={size.uses}
                example={
                    <div style={{ fontSize: size.value }}>
                        Enhancing the specialty pharmacy system for the benefit of pharmacies,
                        payers and patients.
                    </div>
                }
            />
        ))}
    </div>,
];

const tokenfontWeights = [
    <TokenSectionHeader key="11" />,
    <div key="12">
        {fontWeights.map((weight) => (
            <Token
                key={weight.variable_name}
                variableName={weight.variable_name}
                value={weight.value}
                uses={weight.uses}
                example={
                    <div style={{ fontWeight: weight.value }}>
                        Enhancing the specialty pharmacy system for the benefit of pharmacies,
                        payers and patients.
                    </div>
                }
            />
        ))}
    </div>,
];

export const DesignTokens = () => (
    <div>
        <Page
            pageTitle="Design Tokens"
            pageDescription="Design tokens are the values that are used as building blocks and design decisions that make up the Strata Design System."
            pageContent={
                <>
                    <Section title="Border Radius" contentArray={tokenborderRadius} />
                    <Section title="Border Width" contentArray={tokenborderWidth} />
                    <Section title="Spacing" contentArray={tokenSpacing} />
                    <Section title="Font Family" contentArray={tokenfontFamily} />
                    <Section title="Font Sizes" contentArray={tokenfontSizes} />
                    <Section title="Font Weights" contentArray={tokenfontWeights} />
                    {variablesOrganized.map((categoryArr) => (
                        <div key={categoryArr[0].category}>
                            <Section
                                title={categoryArr[0].category}
                                contentArray={[
                                    <TokenSectionHeader key="1" />,
                                    ...categoryArr.map((variable) => (
                                        <Token
                                            key={variable.variable_name}
                                            variableName={variable.variable_name}
                                            value={variable.value}
                                            uses={variable.uses}
                                        />
                                    )),
                                ]}
                            />
                        </div>
                    ))}
                </>
            }
        />
    </div>
);
